import Http from '../http'

export default {
  show(kind, params) {
    return Http.get(`/dash_counters/${kind}`, {
      params: {...params}
    });
  },
  downloadPdf(kind, params) {
    return Http.get(`/dash_counters/${kind}/pdf`, {
      params: {...params},
      responseType: 'blob'
    });
  },
}